import { useTranslation } from 'react-i18next';
import type { ILawPartProps } from './ILawPartProps';
import { groupsOf } from './lawGroups';
import { directionTone } from './lawTones';

/**
 * «Впливи за групами» (прототип v4 lawImp): рядки груп (у порядку варіантів поля), у кожному — впливи кольору напряму з «напрям ·
 * масштаб» праворуч.
 */
export function LawImpacts({ law, labels, onOpen }: ILawPartProps) {
  const { t } = useTranslation();
  const opt = (field: string, v: unknown) => labels.option('ldimp', field, v);
  return (
    <section className="law-sec">
      <div className="law-sec__title">{t('recordPage.law.impacts')}</div>
      {groupsOf(law.of('ldimp'), 'group', labels.order('ldimp', 'group')).map((g) => (
        <div key={g.value} className="law-imp">
          <strong className="law-imp__label">{opt('group', g.value)}</strong>
          <div className="law-imp__chips">
            {g.items.map((r) => (
              <button key={r.id} type="button" className={`law-imp__chip law-t-${directionTone(r.values['direction'])}`} onClick={() => onOpen('ldimp', r)}>
                <span>{r.title}</span>
                <span className="law-imp__meta">{[opt('direction', r.values['direction']), opt('magnitude', r.values['magnitude'])].filter(Boolean).join(' · ')}</span>
              </button>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
